import React, {
  createContext,
  useEffect,
  useState,
  ReactNode,
  useCallback,
} from 'react';
import i18next from 'i18next';
import { useAppDispatch } from 'redux/store-hooks';
import { languageChanged } from 'redux/slices/consent.slice';

interface LanguageContextType {
  currentLanguage: string;
  setLanguage: (language: string) => void;
}

const LanguageContext = createContext<LanguageContextType | undefined>(
  undefined
);

interface LanguageProviderProps {
  children: ReactNode;
}

const getInitialLanguage = (): string => {
  return localStorage.getItem('language') || navigator.language || 'en';
};

export const LanguageProvider: React.FC<LanguageProviderProps> = ({
  children,
}) => {
  const dispatch = useAppDispatch();
  const [currentLanguage, setCurrentLanguage] =
    useState<string>(getInitialLanguage);

  const setLanguage = useCallback(
    (language: string) => {
      localStorage.setItem('language', language);
      i18next.changeLanguage(language);
      setCurrentLanguage(language);
      dispatch(languageChanged(language));
    },
    [dispatch]
  );

  useEffect(() => {
    const language = getInitialLanguage();
    i18next.changeLanguage(language);
    dispatch(languageChanged(language));
  }, [dispatch]);

  const value: LanguageContextType = {
    currentLanguage,
    setLanguage,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageProvider;
